import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarDivisaoEstoqueAutomatico(axios, parametros) { 
    parametros.operacao = 'buscarDivisaoEstoqueAutomatico';       

    let retorno = {}

    await axios.santriGET('/rest/estoque', parametros, 15, false)
    .then(response => {
     retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
     retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno
  },
}


// WEBPACK FOOTER //
// ./src/components/Rest/REstoque/REstoqueBuscarDivisaoEstoqueAutomatico.js